<script lang="ts">
</script>
<div class="size">
	<oc-logo-v1 logo="otto-up" fill-parent data-testid="logo_otto-up"></oc-logo-v1>
</div>
<style lang="scss">
  @use '@otto-ec/otto-components-utils/scss/mixins' as mixins;
  @use "sass:map";

  $l-breakpoint: map.get(mixins.$breakpoints, mixins.$breakpoint-l);
  $medium-and-small-screen: '(width < #{$l-breakpoint})';
  $large-screen: '(width >= #{$l-breakpoint})';

  .size {
    display: inline-block;

    @media #{$large-screen} {
      width: 125px;
      height: 32px;
    }

    @media #{$medium-and-small-screen} {
      width: 78px;
      height: 20px;
    }
  }
</style>
